export default __webpack_public_path__ + "static/Inter-SemiBold-b0b9c035692f884e8635077277ecd338.woff2";